module.exports = systeminformation;